import c from "@mui/icons-material/CloseRounded";
import { styled as t, Button as r } from "@mui/material";
import { jsx as o } from "react/jsx-runtime";
const a = t(r)`
  height: 50px;
  aspect-ratio: 1;
  padding: 5px 5px;
`, l = t(c)`
  width: 100%;
  height: 100%;

  color: #b2b2b2;
`, p = (s) => {
  const {
    className: e,
    onClick: n
  } = s;
  return /* @__PURE__ */ o(a, {
    className: `${e} Custom-Button`,
    onClick: n,
    children: /* @__PURE__ */ o(l, {
      className: "Custom-Icon"
    })
  });
};
export {
  p as default
};
//# sourceMappingURL=CloseButton.js.map
